import './ComponentModel.scss';
import { Modal } from 'react-bootstrap';
import { ComponentModelPopup } from '../../../../interfaces/modal.interface';

type TParams = { modal: ComponentModelPopup };

function ComponentModel({ modal }: TParams) {
  

  return (
    <Modal
      className="modal-main-box"
  
      
      show={modal.Show}
      onHide={modal.HandleClose}
      backdrop="static"
      size='xl'
      
      keyboard={false}>
      <Modal.Header closeButton className="modal-error-header">
        <Modal.Title className="w-100 ">{modal.Title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-40px text-center">
        {modal.Component}
      </Modal.Body>
    </Modal>
  )
}

export default ComponentModel;